<template>
    <v-dialog v-model="dialog" max-width="800">
        <template #activator="{ on, attrs }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card class="contact-dialog">
            <v-app-bar flat height="56" color="#fff">
                <v-spacer />
                <v-btn color="#111" text icon aria-label="닫기" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-app-bar>
            <v-divider />

            <v-card-title>
                <div class="contact-dialog__title">
                    {{ title }}
                </div>
            </v-card-title>
            <v-card-text>
                <v-row class="row--sm">
                    <v-col cols="12">
                        <div class="client-title--sm font-weight-bold grey-1--text">{{ business }} 담당자</div>
                    </v-col>
                    <v-col cols="12">
                        <v-sheet color="rgba(68,132,26,0.1)" class="border-radius-16 pa-24">
                            <v-row v-for="(item, index) in items" :key="index" class="row--sm">
                                <v-col cols="12" sm="auto">
                                    <span class="primary--text">
                                        {{ item.name }}
                                    </span>
                                </v-col>
                                <v-col>
                                    <a :href="item.type === 'tel' ? `tel:${item.text}` : item.type === 'mail' ? `mailto:${item.text}` : item.type === 'link' ? item.text : '#'" target="_blank" rel="noopener noreferrer">
                                        {{ item.text }}
                                    </a>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "숭고한 나눔이 더 빛날 수 있도록 친절히 상담드리겠습니다.",
        },
        business: {
            type: String,
            default: "위드캔 아너스클럽",
        },
        items: {
            type: Array,
            default: () => [
                {
                    name: "연락처",
                    text: "02-2057-2295",
                    type: "tel",
                },
                {
                    name: "이메일",
                    text: "withcan@withcan.co.kr",
                    type: "mail",
                },
            ],
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.contact-dialog {
    border-radius: 8px;
    &__title {
        width: 100%;
        font-size: 20px;
        font-weight: 700;
        color: var(--v-primary-base);
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: currentColor;
        text-align: center;
        padding: 18px 0;
        line-height: 1.35;
        word-break: keep-all;
    }
}
@media (min-width: 768px) {
    .contact-dialog {
        &__title {
            font-size: 28px;
            padding: 24px 0;
        }
        .v-card {
            &__title,
            &__text {
                padding-left: 80px;
                padding-right: 80px;
            }
            &__title {
                padding-top: 40px;
                padding-bottom: 24px;
            }
            &__text {
                padding-bottom: 40px;
            }
        }
    }
}
</style>